import { render } from "./IndexCopy.vue?vue&type=template&id=201c1a78&ts=true"
import script from "./IndexCopy.vue?vue&type=script&lang=ts"
export * from "./IndexCopy.vue?vue&type=script&lang=ts"

import exportComponent from "/var/code/static/vue_drax/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__